import { FC, useCallback, useState, MouseEvent } from 'react';
import { Avatar, Box, IconButton, TableCell, TableRow } from '@mui/material';
import { MdMoreVert as MoreVertIcon } from 'react-icons/md';
import StatusChip from './StatusChip';
import ApiKeyMenu from './ApiKeyMenu';
import { ApiKey } from '../types/api-key-types';
import { getLocalTime } from '../utils/date-utils';
import { apiKeyTypeMap } from '../utils/api-key-utils';

const ApiKeyTableRow: FC<React.PropsWithChildren<ApiKeyTableRowProps>> = ({
  apiKey,
  isUserAdminRole,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: MouseEvent<HTMLElement>) => {
    if (!isUserAdminRole) {
      return;
    }

    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <>
      <TableRow hover role='checkbox' tabIndex={-1}>
        <TableCell>{apiKey.name}</TableCell>
        <TableCell>{apiKeyTypeMap[apiKey.apiKeyRoleType]}</TableCell>
        <TableCell>
          <Box display='flex' alignItems='center' gap={2} ml={2}>
            <Avatar alt={apiKey.createdBy} />
            {apiKey.createdBy}
          </Box>
        </TableCell>
        <TableCell>{getLocalTime(apiKey.iat)}</TableCell>
        <TableCell>{getLocalTime(apiKey.exp)}</TableCell>
        <TableCell>
          {apiKey.lastUsed ? getLocalTime(apiKey.lastUsed) : 'NA'}
        </TableCell>
        <TableCell>
          <StatusChip apiKeyStatus={apiKey.apiKeyStatus} />
        </TableCell>
        <TableCell onClick={handleMenuClick}>
          <IconButton disabled={!isUserAdminRole}>
            <MoreVertIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <ApiKeyMenu
        apiKey={apiKey}
        open={open && isUserAdminRole}
        anchorEl={anchorEl}
        handleClose={handleMenuClose}
        isUserAdminRole={isUserAdminRole}
      />
    </>
  );
};

export interface ApiKeyTableRowProps {
  apiKey: ApiKey;
  isUserAdminRole: boolean;
}

export default ApiKeyTableRow;
